import axios from 'axios';
import {
    deleteToken
} from '@/utils/auth';
import { store } from '@/store/store';
import router from '@/router';

const axiosClient = axios.create();
axiosClient.defaults.headers.common.Accept = `application/json`;

axiosClient.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;
        const statusCode = error.response
            ? error.response.status
            : error.status;
        if (statusCode === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            deleteToken();
            store
                .dispatch('authStore/logoutUser')
                .then(() => router.push({ name: 'Login' }));
            return Promise.reject(error);

        }
        return Promise.reject(error);
    }
);

export default axiosClient;
